import React, { ReactNode } from 'react';
import { Subtext } from '@ui-library/typography';
import theme from '@css/theme';
import { SettingsRowContainer, SettingsInfo, SettingsDescription } from './styles';

interface OwnProps {
  cta?: ReactNode;
  name: string | ReactNode;
  description?: string | ReactNode;
}

type Props = OwnProps;

const SourceSettingsRow = (props: Props) => (
  <SettingsRowContainer>
    <SettingsInfo>
      <Subtext>{props.name}</Subtext>
      <SettingsDescription>
        <Subtext color={theme.token.colorTextDescription} data-testid="description">
          {props.description}
        </Subtext>
      </SettingsDescription>
    </SettingsInfo>
    {props.cta}
  </SettingsRowContainer>
);

/* eslint-disable import/no-default-export */
export default SourceSettingsRow;
